import { render, staticRenderFns } from "./DynamicPricingPercentageDiscount.vue?vue&type=template&id=d06b535e&scoped=true"
import script from "./DynamicPricingPercentageDiscount.vue?vue&type=script&lang=js"
export * from "./DynamicPricingPercentageDiscount.vue?vue&type=script&lang=js"
import style0 from "./DynamicPricingPercentageDiscount.vue?vue&type=style&index=0&id=d06b535e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06b535e",
  null
  
)

export default component.exports